import { LitElement, html } from '@hh/global.js'

class ProductStickyAtc extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    setTimeout(() => {
      this.classList.remove('is-show')
    }, 100)

    this.handleDesktopScroll()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleDesktopScroll() {
    const desktopMainAtc = document.querySelector('[data-product-form-buttons]')
    const footer = document.querySelector('.footer')

    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === desktopMainAtc) {
          if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
            this.classList.remove('is-show')
          } else {
            this.classList.add('is-show')
            this.classList.remove('is-hidden')
          }
        } else if (entry.target === footer) {
          if (entry.isIntersecting) {
            this.classList.remove('is-show')
          } else {
            this.classList.add('is-show')
          }
        }
      })
    }, intersectionOptions)

    this.observer.observe(desktopMainAtc)
    this.observer.observe(footer)
  }

  render() {
    return html`<slot></slot>`
  }
}

if (typeof customElements.get('product-detail-sticky-atc') === 'undefined') {
  customElements.define('product-detail-sticky-atc', ProductStickyAtc)
}
